import { isssUsageAisQuery, useAxiosInstance, usePoQuery } from '@gov-nx/api';

export const useAisQuery = () => {
	const { axiosInstance } = useAxiosInstance();

	return usePoQuery({
		queryKey: ['isss-usage-ais'],
		queryFn: async () => {
			const response = await isssUsageAisQuery(axiosInstance, {
				ucel: 'VYUZITI_ISSS',
			});

			return response.data.seznam ?? [];
		},
	});
};
